




import {
  defineComponent,
  ref,
  onUnmounted,
  onMounted,
} from "@vue/composition-api"
import { useFindOneBooking } from "@/app/reactive/booking"
import { BookingModel } from "@/app/models/booking.model"

export default defineComponent({
  props: {
    booking: {
      type: Object as () => BookingModel,
      required: true,
    },
  },
  setup: (props: { booking: BookingModel }, { root }) => {
    const maxTimeInMinutes = 120
    const timeString = ref<string>("")
    const { findOneBooking } = useFindOneBooking()

    function calcNewTimeString(reservedAt: Date | null) {
      if (reservedAt) {
        const diffMs = Date.now() - reservedAt.getTime()
        const diffMins = Math.round(
          ((diffMs % 86400000) % (maxTimeInMinutes * 60000)) / 60000,
        )
        const countdownInMins = maxTimeInMinutes - diffMins
        timeString.value = `${countdownInMins > 0 ? countdownInMins : 0} Min.`
      } else {
        timeString.value = ""
      }
    }

    async function validReservation(reservedAt: Date | null) {
      if (reservedAt) {
        const diffMs = Date.now() - reservedAt.getTime()
        const diffMins = Math.floor(diffMs / 1000 / 60)

        if (diffMins >= 120) {
          // Will be put to expired by cron-job on Azure
          await findOneBooking(props.booking.referenceId)
          // Redirect to the expired reservations page
          root.$router.push({
            path: `/facility/${props.booking.facilityId}/expired-reservation`,
          })
        }
      }
    }

    onMounted(() => {
      calcNewTimeString(props.booking.reservedAt)
      validReservation(props.booking.reservedAt)
    })

    const timeInterval = setInterval(() => {
      validReservation(props.booking.reservedAt)
      calcNewTimeString(props.booking.reservedAt)
    }, 5000)

    onUnmounted(() => clearInterval(timeInterval))

    return {
      timeString,
    }
  },
})
